import { __awaiter, __generator } from "tslib";
import { fetchGroupsAttributes } from './fetch-groups-attributes';
export var fetchGroupAttributes = function (groupId, includeType) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchGroupsAttributes([groupId], includeType)
                    .then(function (products) { return products ? products[0] : null; })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
